<template>
	<div>
	<div class="wx_title marTop"><span>发表评论</span></div>
	
	<div class="comment">
		
	    <div class="userImg">
	        <img :src="user.avatar" alt="">
	    </div>
		 <el-form :model="form" :rules="rule" ref="form" label-width="0px" style="width: 100%;">
		<el-form-item label="" prop="content">
	    <el-input type="textarea" :autosize="{ minRows: 3}" v-model="form.content" :placeholder="placeholder()"></el-input>
		</el-form-item>
		</el-form>
	</div>
	
	<div class="comment_btn">
	    <el-button @click="submitFarmComment()">发表</el-button>
	</div>
	<div class="comment_list">
	    <div class="title">评论列表 ({{comment_list.length}}条)</div>
	    <div class="item" v-for="item in comment_list" :key="item.id">
	        <div class="item_left">
	            <img :src="item.user.avatar" alt="">
	        </div>
	        <div class="item_right">
	            <div class="name">{{item.user.nickname}}</div>
	            <p>{{item.content}}</p>
	            <div class="bottom">
	                <div class="time">{{item.created_at}}</div>
	                <div class="btns">
	                    <span class="btn reply_btn" @click="replay(item.content,item.id)"><img src="@/assets/images/response.png" alt="" >回复</span>
	                    <span class="btn good_btn" @click="zan(item.id)"><img src="@/assets/images/good.png" alt="">点赞{{item.number}}</span>
	                </div>
	            </div>
	            <div class="child" v-for="(val,key) in item.children" :key="'child'+key" v-if="key<2 && is_all===false">
	                <div class="sub_item" >
	                    <div class="item_left">
	                        <img :src="val.user.avatar" alt="">
	                    </div>
	                    <div class="item_right">
	                        <div class="name">{{val.user.nickname}}</div>
	                        <p>{{val.content}}</p>
	                        <div class="bottom">
	                            <div class="time">{{val.created_at}}</div>
	                            <div class="btns">
	                                
	                                <span class="btn good_btn" @click="zan(item.id)"><img src="@/assets/images/good.png" alt="">点赞{{val.number}}</span>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	                
	                <div class="sub_lenth" v-if="item.children.length>2 && key==1 && is_all===false" @click="all()">全部{{item.children.length}}条回复</div>
	            </div>
				<div class="child" v-for="(val,key) in item.children" :key="'child'+key" v-if="is_all===true">
				    <div class="sub_item" >
				        <div class="item_left">
				            <img :src="val.user.avatar" alt="">
				        </div>
				        <div class="item_right">
				            <div class="name">{{val.user.nickname}}</div>
				            <p>{{val.content}}</p>
				            <div class="bottom">
				                <div class="time">{{val.created_at}}</div>
				                <div class="btns">
				                    
				                    <span class="btn good_btn" @click="zan(item.id)"><img src="@/assets/images/good.png" alt="">点赞{{val.number}}</span>
				                </div>
				            </div>
				        </div>
				    </div>
				    
				   
				</div>
	        </div>
			
			        
				
				
				       
				  
			</div>
	    </div>
	</div>
	</div>
</template>

<script>
import {
		submitFarmComment,		
		getFarmCommentList,
		setFarmCommentZan
	} from '@/api/comment.js'
		export default {
			name: "Comment",
			props: {
				farm_id: {
					type: String,
					default: 0
				},
				user: {
					type: Array,
					default: ()=>{}
				},

			},
			data() {
				return {
                      
					  form: {
						type:1,  
					  	content: '',
						parent_id:0

					  },
					  is_all:false,
					  placeholder_text:'',
					  comment_list:[],
					  rule: {
					  	content: [{
					  		required: true,
					  		message: '必填',
					  		trigger: 'blur'
					  	}],
					  
					  },
				}
				},
				created() {
					this.get_farm_comment_list()
				},
				methods:{
					zan(id){
						setFarmCommentZan(id).then(resp=>{
							this.get_farm_comment_list()
						})
					},
					all(){
						this.is_all=true
					},
					replay(text,pid){
						console.log(text)
						this.form.parent_id=pid
						
					
						this.placeholder_text="回复"+text+":";
						this.placeholder()
						
					},
					get_farm_comment_list(){
						 getFarmCommentList(this.farm_id).then(resp=>{
							   this.comment_list=resp
						 } )
					},
					placeholder(){
						 return this.placeholder_text?this.placeholder_text:"请填写留言内容";
					},
					submitFarmComment(){
						this.$refs["form"].validate((valid) => {
							if (valid) {
								submitFarmComment(this.farm_id,this.form).then(resp=>{
									this.get_farm_comment_list()
								})
							} else {
								this.holdShow = false
								return false;
							}
						});
						
					}
				}
			}
		

</script>

<style>
</style>
